import { Link } from "react-router-dom";
import { ROUTES, trail } from "@/content/routes";

export const Breadcrumbs = ({ routeKey, via }) => {
  const chain = trail(routeKey, via);
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="font-mono text-[11px] uppercase tracking-[0.18em] text-o-dim">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {chain.map((k, i) => (
          <li key={k} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden className="opacity-50">/</span>}
            {i === chain.length - 1 ? (
              <span aria-current="page" className="text-o-text">{ROUTES[k].label}</span>
            ) : (
              <Link to={ROUTES[k].path} data-testid={`breadcrumb-${k}`} className="transition-colors hover:text-o-accent">
                {ROUTES[k].label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
